import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const GA_ID = "G-XYD545GP97";
const ADS_ID = "AW-18266948529";
const STORAGE_KEY = "vc_cookie_consent";

function loadGA() {
  if (typeof window === "undefined" || window.__vc_ga_loaded) return;
  window.__vc_ga_loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
  gtag("config", ADS_ID);
}

const COPY = {
  de: {
    text: "Wir nutzen Cookies & Google Analytics, um unsere Website zu verbessern.",
    accept: "Akzeptieren",
    decline: "Ablehnen",
  },
  en: {
    text: "We use cookies & Google Analytics to improve our website.",
    accept: "Accept",
    decline: "Decline",
  },
};

export default function CookieConsent() {
  const { lang } = useI18n();
  const location = useLocation();
  const onApps = location.pathname.startsWith("/apps");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (onApps) return; // App-Studio-Seiten: kein Analytics/Tracking
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "accepted") loadGA();
    else if (!v) setVisible(true);
  }, [onApps]);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    loadGA();
    setVisible(false);
  };
  const decline = () => {
    localStorage.setItem(STORAGE_KEY, "declined");
    setVisible(false);
  };

  if (onApps || !visible) return null;
  const c = COPY[lang] || COPY.de;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 right-4 z-[60] max-w-sm rounded-2xl border border-white/10 bg-black/90 backdrop-blur-xl p-4 shadow-[0_0_40px_rgba(255,0,80,0.2)]"
    >
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 shrink-0 rounded-lg bg-[#FF0050]/10 border border-[#FF0050]/30 flex items-center justify-center text-[#FF0050]">
          <Cookie className="h-4 w-4" />
        </div>
        <div className="flex-1">
          <p className="text-zinc-300 text-sm leading-relaxed mb-3">{c.text}</p>
          <div className="flex items-center gap-2">
            <button
              onClick={accept}
              data-testid="cookie-accept"
              className="text-xs font-bold bg-[#FF0050] hover:bg-[#E00046] text-white rounded-full px-4 py-2 transition hover:shadow-[0_0_20px_rgba(255,0,80,0.5)]"
            >
              {c.accept}
            </button>
            <button
              onClick={decline}
              data-testid="cookie-decline"
              className="text-xs font-medium text-zinc-400 hover:text-white border border-white/10 hover:border-white/30 rounded-full px-4 py-2 transition"
            >
              {c.decline}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
